import { useCalendar } from '../../contexts/CalendarContext';
import { getPossessionModel } from '../../utils/dataFields';
import VehicleInfo from './VehicleInfo';
import AnimalInfo from './AnimalInfo';
import RealEstateInfo from './RealEstateInfo';

const DEFAULT_LABELS = {
  vehicle: 'Vehicle Information',
  animal: 'Animal Information',
  real_estate: 'Property Information',
};

const COMPONENTS = {
  vehicle: VehicleInfo,
  animal: AnimalInfo,
  real_estate: RealEstateInfo,
};

/**
 * Renders the possession section for the calendar's configured possession_model
 * (vehicle / animal / real_estate), or nothing when none is configured.
 */
const PossessionSection = ({ customerRecords }) => {
  const { fields } = useCalendar();
  const model = getPossessionModel(fields);
  const Component = model && COMPONENTS[model];
  if (!Component) return null;

  const label = fields?.possession_label || DEFAULT_LABELS[model];

  return (
    <div className="form-section">
      <h3 className="section-title">{label}</h3>
      <Component customerRecords={customerRecords} />
    </div>
  );
};

export default PossessionSection;
